import { BODY_SM_SM_STYLES, HEADING_SM_STYLES } from '@constants/text.ts';
import { styled } from 'styled-components';

export const WelcomeSectionWrapper = styled.div`
    .ant-alert {
        align-items: center;
    }
    .ant-alert-description {
        margin-left: 0;
        ${BODY_SM_SM_STYLES};
    }
    .ant-alert-message {
        margin-bottom: 0;
        ${HEADING_SM_STYLES};
    }
    button {
        font-size: 14px !important;
        .ant-btn-icon {
            margin-top: 8px;
        }
    }
`;
